export default "__VITE_ASSET__d07cc32b__"